import { useParams } from "react-router-dom";
import i18next from "i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { News_EN } from "../../Constants/News";
import "./NewPage.css";
import NotFound from "../404";
import { useEffect, useState } from "react";
import { Meta } from "../../Components/Helpers/Meta";

const New = () => {
  const { link, lang } = useParams();
  const [language, setLanguage] = useState(lang || i18next.language);
  const [newItem, setNewItem] = useState(null);
  const [itemTitle, setItemTitle] = useState("");
  const [itemImg, setItemImg] = useState(null);

  // Sync with i18next language if it changes
  useEffect(() => {
    const onLangChange = (lng) => setLanguage(lng);
    i18next.on("languageChanged", onLangChange);
    return () => {
      i18next.off("languageChanged", onLangChange);
    };
  }, []);

  useEffect(() => {
    const foundItem =
      News_EN.find((item) => item.link === link) ||
      News_EN.find((item) => item.link_tr === link);

    if (!foundItem) {
      window.history.replaceState({ status: 404 }, "", window.location.href);
      return;
    }

    setNewItem(foundItem);
    setItemImg(foundItem.img);

    const isTR = language === "tr";

    const title = isTR ? foundItem.title_tr : foundItem.title;
    const description = isTR ? foundItem.desc_tr : foundItem.desc;
    const imagePath = foundItem.img?.default || foundItem.img;
    const fullImageUrl = `https://cevher.com${imagePath}`;

    document.title = title;
    i18next.changeLanguage(isTR ? "tr" : "en");
    setItemTitle(title);

    const setOrCreateMeta = (selector, attrName, value, isProperty = false) => {
      let meta = document.querySelector(selector);
      if (meta) {
        meta.setAttribute(isProperty ? "property" : "name", attrName);
        meta.setAttribute("content", value);
      } else {
        meta = document.createElement("meta");
        meta.setAttribute(isProperty ? "property" : "name", attrName);
        meta.setAttribute("content", value);
        document.head.appendChild(meta);
      }
    };

    setOrCreateMeta('meta[name="description"]', "description", description);
    setOrCreateMeta('meta[property="og:title"]', "og:title", title, true);
    setOrCreateMeta('meta[property="og:description"]', "og:description", description, true);
    setOrCreateMeta('meta[property="og:image"]', "og:image", fullImageUrl, true);
    setOrCreateMeta('meta[property="og:url"]', "og:url", window.location.href, true);
    setOrCreateMeta('meta[property="og:type"]', "og:type", "article", true);

    let linkImg = document.querySelector('link[rel="image_src"]');
    if (linkImg) {
      linkImg.setAttribute("href", fullImageUrl);
    } else {
      linkImg = document.createElement("link");
      linkImg.setAttribute("rel", "image_src");
      linkImg.setAttribute("href", fullImageUrl);
      document.head.appendChild(linkImg);
    }
  }, [link, language]);

  const fullUrl = `https://cevher.com${itemImg}`;

  if (newItem) {
    return (
      <>
        <Meta title={itemTitle} description={itemTitle} lang={language} metaimg={fullUrl} />
        <Navbar />
        <div className="c-wrapper">
          <div className="c-hero">
            <div className="c-hero-background">
              <picture>
                <img
                  className="c-hero-image"
                  alt=""
                  src={require("../../assets/hero/news.2f117a4c.jpg")}
                />
              </picture>
            </div>
          </div>
          <div className="c-container">
            <div className="c-new-page-row">
              <div className="c-new-page-col">
                <div className="c-new-page-container" style={{ textAlign: "center", marginTop: "3rem" }}>
                  <div className="c-new-page-title">
                    {language === "en" ? newItem.title : newItem.title_tr}
                  </div>
                  <div className="c-new-page-date" style={{ marginTop: "1rem" }}>
                    {newItem.date}
                  </div>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: language === "en" ? newItem.body : newItem.body_tr,
                  }}
                  style={{ marginTop: "3rem" }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return <NotFound />;
};

export default New;



/*
import { Navigate, useParams, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { News_EN } from "../../Constants/News";
import "./NewPage.css";
import NotFound from "../404";
import { useEffect, useState } from "react";
import { Meta } from "../../Components/Helpers/Meta";

const New = () => {
  const { link, lang } = useParams();
  let insideLanguage=i18next.language;
  let language = lang!==undefined ? lang : insideLanguage;
  console.log(language);

  
  
  const [newItem, setNewItem] = useState(null);
  const [itemImg, setItemImg] = useState(null);
  const [itemTitle,setItemTitle]=useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const foundItem =
      News_EN.find((item) => item.link === link) ||
      News_EN.find((item) => item.link_tr === link);
  
    if (!foundItem) {
      window.history.replaceState({ status: 404 }, "", window.location.href);
      return;
    }
  
    setNewItem(foundItem);
    setItemImg(foundItem.img);
  
    const isTR = language === "tr";
  
    const title = isTR ? foundItem.title_tr : foundItem.title;
    const description = isTR ? foundItem.desc_tr : foundItem.desc;
    const imagePath = foundItem.img?.default || foundItem.img;
    const fullImageUrl = `https://cevher.com${imagePath}`;
  
    document.title = title;
    i18next.changeLanguage(isTR ? "tr" : "en");
    setItemTitle(title);
  
    const setOrCreateMeta = (selector, attrName, value, isProperty = false) => {
      let meta = document.querySelector(selector);
      if (meta) {
        meta.setAttribute(isProperty ? "property" : "name", attrName);
        meta.setAttribute("content", value);
      } else {
        meta = document.createElement("meta");
        meta.setAttribute(isProperty ? "property" : "name", attrName);
        meta.setAttribute("content", value);
        document.head.appendChild(meta);
      }
    };

  
    // SEO ve Open Graph meta etiketleri
    setOrCreateMeta('meta[name="description"]', "description", description);
    setOrCreateMeta('meta[property="og:title"]', "og:title", title, true);
    setOrCreateMeta('meta[property="og:description"]', "og:description", description, true);
    setOrCreateMeta('meta[property="og:image"]', "og:image", fullImageUrl, true);
    setOrCreateMeta('meta[property="og:url"]', "og:url", window.location.href, true);
    setOrCreateMeta('meta[property="og:type"]', "og:type", "article", true);

    let linkImg = document.querySelector('link[rel="image_src"]');
      if (linkImg) {
        linkImg.setAttribute("rel", "image_src");
        linkImg.setAttribute("href", fullImageUrl);
      } else {
        linkImg = document.createElement("link");
        linkImg.setAttribute("rel", "image_src");
        linkImg.setAttribute("href", fullImageUrl);
        document.head.appendChild(linkImg);
      }
  
  }, [link, language]);
  

  const imagesrc = itemImg;
  const fullUrl =`https://cevher.com${imagesrc}`;

  if (newItem) {
    return (
      <>
       <Meta title={itemTitle} description={itemTitle} lang={lang} metaimg={fullUrl} />
        <Navbar />
        <div className="c-wrapper">
          <div className="c-hero">
            <div className="c-hero-background">
              <picture>
                <img
                  className="c-hero-image"
                  alt=""
                  src={require("../../assets/hero/news.2f117a4c.jpg")}
                />
              </picture>
            </div>
          </div>
          <div className="c-container">
            <div className="c-new-page-row">
              <div className="c-new-page-col">
                <div
                  className="c-new-page-container"
                  style={{ textAlign: "center", marginTop: "3rem" }}
                >
                  <div className="c-new-page-title">
                    {insideLanguage === "en" ? newItem.title : newItem.title_tr}
                  </div>
                  <div
                    className="c-new-page-date"
                    style={{ marginTop: "1rem" }}
                  >
                    {newItem.date}
                  </div>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: insideLanguage === "en" ? newItem.body : newItem.body_tr,
                  }}
                  style={{ marginTop: "3rem" }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
// 404 Page
  else {
    return (
     <NotFound />
  );
  }
};

export default New;

*/
